module.exports = __webpack_public_path__ + "static/media/itemMenuBg.ef11a4fe.jpg";